import { usePage } from '@inertiajs/vue3'

interface User {
  permissions: Record<string, boolean>
  role: string
}

const usePermissions = {
  methods: {
    hasPerm(permission: string): boolean {
      const user = (usePage().props as unknown as { user: User }).user

      if (Object.prototype.hasOwnProperty.call(user.permissions, permission)) {
        return user.permissions[permission]
      }
      return false
    },
    hasRole(role: string): boolean {
      const user = (usePage().props as unknown as { user: User }).user
      return user.role === role
    },
    hasAnyRole(roles: string[]): boolean {
      const user = (usePage().props as unknown as { user: User }).user
      return roles.includes(user.role)
    },
    hasNotRole(role: string): boolean {
      const user = (usePage().props as unknown as { user: User }).user
      return user.role !== role
    },
    isClient(): boolean {
      return this.hasRole('client')
    },
    isAgency(): boolean {
      return this.hasRole('agency')
    },
    isManager(): boolean {
      return this.hasRole('manager')
    },
    isPro(): boolean {
      return this.hasRole('pro')
    },
  },
}

export { usePermissions }
